import styled from 'styled-components/macro';
import { Scrollbar, PopUpView } from '~/components';

export const Header = styled.header`
  display: block;
  position: sticky;
  left: 0;
  top: 0;
  height: 65px;
  width: 100%;
  background-color: ${({ theme }) => theme.white};
  padding: 15px 50px 0 50px;
  z-index: 13;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: 48px;
    padding: 14px 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const LaLigaLogo = styled.img`
  position: relative;
  height: 21.6px;
  width: auto;
  float: left;
  margin-right: 10px;
  margin-top: 8px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: 21.6px;
    margin-right: 15px;
    margin-top: 0px;
  }
`;

export const BrandLogo = styled.img`
  position: relative;
  height: 21.6px;
  width: auto;
  float: left;
  margin-left: 15px;
  margin-top: 8px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: 21.6px;
    margin: 0 15px;
  }
`;

export const AppName = styled.p`
  position: relative;
  color: ${({ theme }) => theme.headerBlack};
  margin: 0 0 0 15px;
  height: 35px;
  line-height: 35px;
  font-family: ${({ theme }) => theme.primaryFontHead};
  font-size: 29px;
  padding-left: 15px;
  letter-spacing: 0.866px;
  float: left;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    font-family: ${({ theme }) => theme.primaryFontHead};
    height: 35px;
    font-size: 29px;
    line-height: 20px;
    margin: 0;
    text-align: center;
    display: flex;
    align-items: center;
  }
`;

export const HeaderBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  opacity: 0.1;
  background-repeat: no-repeat;
  background-position: center -780px;
  background-size: cover;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    background-size: 150%;
    background-position: center -150px;
    z-index: -1;
  }
`;

export const ShowMenu = styled.div`
  padding-top: 2px;
  height: 18px;
  cursor: pointer;
  z-index: 5;
  margin-right: 15px;
`;

export const MenuMobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: calc(100vh - 48px);
  background-color: ${({ theme }) => theme.black};
  padding: 55px;

  > div {
    &:first-child {
      display: flex;
      flex-direction: column;
      .link,
      a {
        cursor: pointer;
        width: 100%;
        height: 55px;
        padding: 20px 0;
        display: flex;
        align-items: center;
        text-transform: capitalize;
        font-size: ${({ theme }) => theme.button}px;
        color: ${({ theme }) => theme.white};
        svg {
          margin-left: 10px;
        }
      }
    }
    &:last-child {
      height: 70px;
    }
  }
`;

export const MenuItem = styled.div``;

export const Separator = styled.div`
  width: 30px;
  border-bottom: 1px solid ${({ theme }) => theme.gray2};
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const ContainerScrollbar = styled(Scrollbar)`
  background-color: ${({ theme }) => theme.light};
`;

export const PopUpViewHeader = styled(PopUpView)`
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth};` : null)}
`;
